import React from 'react';

import { LinkCard, getCardPaths } from './link_card';

import type { LinkCardRecord } from './link_card';
import type { ProjectToolCall } from '../types';

interface ProjectCard extends LinkCardRecord {
  address: string | null;
  displayName: string | null;
}

interface ProjectCardsProps {
  toolCalls: ProjectToolCall[];
}

export function ProjectCards({ toolCalls }: ProjectCardsProps) {
  return (
    <>
      {getCardPaths(toolCalls).map(path => (
        <LinkCard key={path} path={path}>
          {(project: ProjectCard) => (
            <>
              <div className="fw-semibold text-truncate">{project.displayName}</div>
              {project.address && <div className="small text-muted text-truncate">{project.address}</div>}
            </>
          )}
        </LinkCard>
      ))}
    </>
  );
}
